export default __webpack_public_path__ + "static/media/camion-pequeno.0e030e8b.webp";